import styled from 'styled-components'

import { SeparatorVertical } from './common'
import { TradingPairExploreItemMetricsFees } from './pair-explore-item-metrics-fees'
import { TradingPairExploreItemMetricsLiquidity } from './pair-explore-item-metrics-liquidity'
import { TradingPairExploreItemMetricsMcap } from './pair-explore-item-metrics-mcap'
import { TradingPairExploreItemMetricsTxs } from './pair-explore-item-metrics-txs'
import { TradingPairExploreItemMetricsVolume } from './pair-explore-item-metrics-volume'

import type { PairMetrics, PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  pair: PairModel
  statsPeriod: PairMetrics.MetricsSpan
  withTrailingSeparator?: boolean
} & ClassNameProps

export const TradingPairExploreItemMetricsSummary: React.FC<Props> = ({
  pair,
  className,
  statsPeriod,
  withTrailingSeparator = false,
}) => {
  return (
    <Root className={className}>
      <TradingPairExploreItemMetricsMcap pair={pair} />
      <SeparatorVertical vertical />

      <TradingPairExploreItemMetricsVolume
        pair={pair}
        volumePeriod={statsPeriod}
      />
      <SeparatorVertical vertical />

      <TradingPairExploreItemMetricsLiquidity pair={pair} />
      <SeparatorVertical vertical />

      <TradingPairExploreItemMetricsTxs pair={pair} statsPeriod={statsPeriod} />
      <SeparatorVertical vertical />

      <TradingPairExploreItemMetricsFees pair={pair} />
      {withTrailingSeparator && <SeparatorVertical vertical />}
    </Root>
  )
}

const Root = styled.div`
  color: var(--textA-8);

  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: auto;
  align-items: center;

  gap: 3px;

  justify-content: end;
  text-transform: uppercase;
`
